/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { enableProdMode, LOCALE_ID, DEFAULT_CURRENCY_CODE, importProvidersFrom, ErrorHandler, inject } from '@angular/core';

// import { PostModule } from './app/post/post.module';
// import { ToDoModule } from './app/todo/todo.module';
import { environment } from '@src/environments/environment';
import { AppComponent } from '@src/app/app.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { appRoutes } from '@src/app/routes/app-router';
import { withRouterConfig, provideRouter, withNavigationErrorHandler } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LayoutModule } from '@angular/cdk/layout';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@src/app/app-routing.module';
import { TINYMCE_SCRIPT_SRC, EditorModule } from '@tinymce/tinymce-angular';
import { APP_BASE_HREF, NgOptimizedImage } from '@angular/common';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { OurErrorHandlerService } from '@src/app/shared/our-error-handler-service';
import { tenantIdInterceptor } from '@src/app/shared/tenantIdInterceptor';

/**  Kill Service Worker Registrations
 * We used to have a service worker, we need to leave this here for a year or two from Jan 2025 to kill off for all existing users...
 * */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule, BrowserModule, DragDropModule, EditorModule, FormsModule, NgOptimizedImage, LayoutModule, MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule,
      //    MatMomentDateModule,
      MatNativeDateModule, MatRadioModule, MatSelectModule, MatSidenavModule, MatSnackBarModule, MatStepperModule, MatProgressSpinnerModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, ReactiveFormsModule, ScrollingModule),
    { provide: APP_BASE_HREF, useValue: (environment.appBaseHref) },
    { provide: TINYMCE_SCRIPT_SRC, useValue: (environment.baseHref + 'tinymce/tinymce.min.js') },
    { provide: LOCALE_ID, useValue: 'en-IE' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
    { provide: ErrorHandler, useClass: OurErrorHandlerService },
    //      { provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    provideAnimations(),
    provideHttpClient(withInterceptors([tenantIdInterceptor])),
    { // Seems to prevent aria errors that happen if angular tries to autofocus.
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
        restoreFocus: false
      } as MatDialogConfig
    },
    provideRouter(
        appRoutes,
        withRouterConfig({ onSameUrlNavigation: 'reload' }),
        withNavigationErrorHandler((error) => {
            const oehs = inject(OurErrorHandlerService);
            oehs.handleError(error);
        })
    )      
  ]
})
  .catch(err => console.error(err));
